var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 23.636V4.5A4.5 4.5 0 0 1 4.5 0h19.136a4.5 4.5 0 0 1 3.182 1.318l19.864 19.864a4.5 4.5 0 0 1 0 6.364L27.546 46.682a4.5 4.5 0 0 1-6.364 0L1.318 26.818A4.5 4.5 0 0 1 0 23.636zM10.5 6a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z"
  })));
};
export default SvgTag;